export type TendencyZone = 'lower' | 'target' | 'higher';

export const AMH_RANGE = { min: 2, max: 60 };
export const WEIGHT_RANGE = { min: 40, max: 120 };

const clamp = (v: number, lo = 0, hi = 1) => Math.min(hi, Math.max(lo, v));

/**
 * Illustrative response tendency (0–1) for a uniform, non-individualized start.
 * AMH dominates (log scale); body weight is only a small modifier.
 * Not a clinical prediction.
 */
export function responseTendency(amh: number, weight: number): number {
  const amhT = (Math.log(amh) - Math.log(AMH_RANGE.min)) / (Math.log(AMH_RANGE.max) - Math.log(AMH_RANGE.min));
  const weightT = (weight - WEIGHT_RANGE.min) / (WEIGHT_RANGE.max - WEIGHT_RANGE.min);
  return clamp(0.06 + 0.86 * amhT - 0.12 * (weightT - 0.5));
}

export function zoneFor(position: number): TendencyZone {
  if (position < 0.34) return 'lower';
  if (position > 0.66) return 'higher';
  return 'target';
}

export const zoneLabels: Record<TendencyZone, string> = {
  lower: 'Lower response tendency',
  target: 'Target zone',
  higher: 'Higher response tendency',
};
